import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useHero } from '../../context/CMSContext';

const Hero: React.FC = () => {
  const hero = useHero();

  return (
    <section className="relative h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src={hero.backgroundImage}
          alt={hero.titleLine1}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-900/70" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <span className="inline-block px-4 py-1 rounded-full bg-gold-600/20 border border-gold-600/30 text-gold-500 text-[1.4rem] font-semibold mb-6">
            {hero.tagline}
          </span>
          <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
            {hero.titleLine1}
            <br />
            <span className="text-gold-500">{hero.titleLine2}</span>
          </h1>
          <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl">{hero.description}</p>
          <div className="flex flex-wrap gap-4">
            <Link
              to={hero.primaryButtonLink}
              className="inline-flex items-center gap-3 bg-gold-600 hover:bg-gold-700 text-white px-10 py-4 rounded-full text-lg font-semibold transition-all transform hover:-translate-y-0.5"
            >
              <span className="h-2.5 w-2.5 rounded-full bg-white" />
              {hero.primaryButtonText}
            </Link>
            <Link
              to={hero.secondaryButtonLink}
              className="inline-flex items-center gap-3 bg-white/10 hover:bg-white/20 text-white border border-white/30 px-10 py-4 rounded-full text-lg font-semibold backdrop-blur-sm transition-all transform hover:-translate-y-0.5"
            >
              <span className="h-2.5 w-2.5 rounded-full bg-gold-400" />
              {hero.secondaryButtonText}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
